import { PaymentMethod } from "../../../../common/enums";
import {
  DetailedPaymentPrefUnionObjectType,
  type RedactedPaymentPref,
} from "../../common/types";
import { getPaymentMethod } from "../../common/utils";

export const getPaymentMethodText = (
  paymentPref: DetailedPaymentPrefUnionObjectType | RedactedPaymentPref,
): string => {
  const paymentMethod = getPaymentMethod(paymentPref);

  switch (paymentMethod) {
    case PaymentMethod.ACH:
      return "ACH direct deposit";
    case PaymentMethod.Wire:
      return "Wire transfer";
    case PaymentMethod.Check:
      return "Check";
    case PaymentMethod.BACS:
      return "UK bank transfer (BACS/FPS/CHAPS)";
    case PaymentMethod.SEPA:
      return "Europe bank transfer (SEPA)";
    case PaymentMethod.EFT:
      return "Canada bank transfer (EFT)";
    case PaymentMethod.BECS:
      return "Australia direct entry (BECS)";
    case PaymentMethod.Other:
      return "Other";
    default:
      return "";
  }
};

export const getTitle = (
  paymentPref: DetailedPaymentPrefUnionObjectType | RedactedPaymentPref,
): string => {
  if ("bankInfoRedacted" in paymentPref) {
    return paymentPref.bankInfoRedacted ?? "";
  }
  return "";
};
